import {AdminUser} from "./admin-user.model";
import {SearchPage} from "./search-page.model";

export class AdminUserList extends SearchPage {
  results: AdminUser[]
}
